export { default } from "./BoxRelatedToChanel"
